import { useState, type KeyboardEvent } from 'react';
import { X } from 'lucide-react';

interface CoordinatorInputProps {
  id: string;
  value: string[];
  onChange: (coordinators: string[]) => void;
  disabled?: boolean;
}

export function CoordinatorInput({ id, value, onChange, disabled = false }: CoordinatorInputProps) {
  const [draft, setDraft] = useState('');

  const addCoordinator = () => {
    const coordinator = draft.trim();
    if (!coordinator) return;
    if (!value.some((name) => name.toLocaleLowerCase() === coordinator.toLocaleLowerCase())) {
      onChange([...value, coordinator]);
    }
    setDraft('');
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    addCoordinator();
  };

  return (
    <div className="coordinator-editor">
      <div className="coordinator-input">
        {value.map((coordinator) => (
          <span className="coordinator-chip" key={coordinator}>
            {coordinator}
            <button
              type="button"
              aria-label={`Remove ${coordinator}`}
              title={`Remove ${coordinator}`}
              disabled={disabled}
              onClick={() => onChange(value.filter((name) => name !== coordinator))}
            >
              <X aria-hidden="true" />
            </button>
          </span>
        ))}
        <input
          id={id}
          type="text"
          value={draft}
          disabled={disabled}
          placeholder={value.length === 0 ? 'Enter a coordinator name' : 'Add another coordinator'}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      <button type="button" disabled={disabled || !draft.trim()} onClick={addCoordinator}>
        Add
      </button>
    </div>
  );
}
